export const BANNERS_WIDGET = 'podtatrze';
export const CAROUSEL_WIDGET = 'carousel_menu';
export const HORSE_RACING_WIDGET = 'racing-horse';
export const GREYHOUND_RACING_WIDGET = 'racing-greyhound';
export const BETFEED_WIDGET = 'betfeed_widget';
export const POPULAR_WIDGET = 'popular_events_widget';
export const INPLAY_WIDGET = 'homepage_featured_inplay';
export const TROTTING_WIDGET = 'trotting';
export const SPOTLIGHT_WIDGET = 'spotlight';
export const GOLF_SPORT_WIDGET = 'golf';
export const ARTICLE_WIDGET = 'long-article';

export const MADE_FOR_YOU_WIDGET = 'madeforyou';

export const ODDS_BOOST_WIDGET = 'odds_boost_widget';
export const XSELL_WIDGET = 'xsell_widget';
export const POKER_BLAST_WIDGET = 'poker_blast';

export const HOMEPAGE_LOCATION = 'homepage';
